import {Component} from '@angular/core';

@Component({
    selector: 'tfl-leave-page-icon',
    template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="float:left;">
            <g fill="none" fill-rule="evenodd">
                <path fill="#000" fill-rule="nonzero" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                <path d="M0 0h24v24H0z"/>
            </g>
        </svg>
    `
})
export class LeavePageIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/leave.page.icon.ts